import { Header } from "components/atoms/Typography";
import CarbonPoliciesTable from "./Components/CarbonPoliciesTable";
import styles from "./CarbonPoliciesPage.module.scss";

function CarbonPoliciesPage() {
    return (
        <div className={styles.carbonPoliciesPage}>
            <div className={styles.carbonPolicies}>
                <div className={styles.carbonPoliciesHeader}>
                    <Header size="large">Carbon Policies</Header>
                </div>
                <CarbonPoliciesTable />
            </div>
        </div>
    );
}

export default CarbonPoliciesPage;
